import { createAsyncThunk } from "@reduxjs/toolkit";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import axios from "axios";
import { count } from "console";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
// import { LoDashStatic } from 'lodash'
const API_URL = process.env.REACT_APP_BASE_URL;
const headers = {
  "Content-Type": "application/json",
};

export interface Organisation {
  id?: number;
  packageName: string;
  districtCode: string;
  districtName: string;
  state: string;
  status: boolean;
  createBy?: string;
  updatedBy?: string;
  createDate?: string;
  updateDate?: string;
}
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const fetchOrganisation1 = createAsyncThunk(
  "organisation/fetchOrganisation",
  async ({
    page,
    pageSize,
    search,
    sort,
    order,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: ColumnFiltersState;
  }) => {
    try {
      console.log("fetchOrganisation1 called with:", {
        page,
        pageSize,
        search,
        filters,
      });
      const token = localStorage.getItem("authToken");
      if (!token) {
        throw new Error("No authentication token found");
      }

      const response: any = await Axios.get(
        `${API_ENDPOINT?.USER_MANAGEMENT?.ORGANIZATION?.LIST}`,
        {
          params: {
            page,
            page_size: pageSize,
            search: search || undefined,
            filters: filters ? JSON.stringify(filters) : undefined,
          },
        }
      );

      const responseData = response.data;

      return {
        data: responseData?.results || [],
        rowCount: responseData?.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchOrganisation1 error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch Organisations");
    }
  }
);

export const fetchOrganisations = createAsyncThunk(
  "organisation/fetchOrganisation",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: ColumnFiltersState;
  }) => {
    try {
      const params: Record<string, any> = {
        page,
        page_size: pageSize,
      };

      if (search) params.search = search?.trim() || "";

      // Build the ordering param for the API
      if (sort) {
        params.ordering = order === "desc" ? `-${sort}` : sort;
      }

      //Add each filter as a query param (e.g. organization_name=...)
      if (filters && Array.isArray(filters)) {
        filters.forEach((filter) => {
          const { id, value } = filter;
          if (!id || value === undefined || value === "") return;
          if (
            (id === "updated_at" || id === "created_at") &&
            typeof value === "object"
          ) {
            const { from_date, to_date } = value as {
              from_date?: string;
              to_date?: string;
            };
            if (from_date) params[`${id}_from`] = from_date;
            if (to_date) params[`${id}_to`] = to_date;
          } else {
            params[id] = value;
          }
        });
      }
      if (filters && Array.isArray(filters)) {
        filters.forEach((filter) => {
          const { id, value } = filter;
          if (!id || value === undefined || value === "") return;
          if (
            (id === "updated_at" || id === "created_at") &&
            typeof value === "object"
          ) {
            const { from_date, to_date } = value as {
              from_date?: string;
              to_date?: string;
            };
            if (id === "updated_at") {
              if (from_date) params["updated_at_from"] = from_date;
              if (to_date) params["updated_at_to"] = to_date;
            }
            if (id === "created_at") {
              if (from_date) params["created_at_from"] = from_date;
              if (to_date) params["created_at_to"] = to_date;
            }
          } else {
            params[id] = value;
          }
        });
      }

      const response: any = await Axios.get(
        `${API_ENDPOINT?.USER_MANAGEMENT?.ORGANIZATION?.LIST}`,
        { params }
      );

      const responseData = response.data;
      return {
        data: responseData?.data || responseData?.results || [],
        rowCount: responseData?.total_records || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchOrganisation error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch organisations");
    }
  }
);

export const fetchOrganisationById = createAsyncThunk(
  "organisation/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${API_ENDPOINT?.USER_MANAGEMENT?.ORGANIZATION?.DETAIL(id)}`
      );
      return response;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to fetch organisations by ID"
      );
    }
  }
);

export const updateOrganisation = createAsyncThunk<
  any, // return type
  { id: string; orgData: any }, // argument type
  { rejectValue: string } // reject type
>(
  "organisation/updateOrganisation",
  async ({ id, orgData }, { rejectWithValue }) => {
    try {
      const response = await Axios.put(
        API_ENDPOINT.USER_MANAGEMENT.ORGANIZATION.UPDATE(id),
        orgData
      );

      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to update organisation"
      );
    }
  }
);

export const updateStatusInOrg = createAsyncThunk<
  any, // return type
  string, // argument type (id)
  { rejectValue: string } // rejected value type
>("organisation/updateOrganisation2", async (id, { rejectWithValue }) => {
  try {
    const response = await Axios.patch(
      API_ENDPOINT.USER_MANAGEMENT.ORGANIZATION.STATUS_UPDATE(id)
    );

    return response.data.data;
  } catch (error: any) {
    return rejectWithValue(
      error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to update organisation status"
    );
  }
});

export const addOrganisation = createAsyncThunk<
  any, // return type
  any, // argument type
  { rejectValue: string } // reject value type
>("organisation/addOrganisation", async (packageData, { rejectWithValue }) => {
  try {
    const response = await Axios.post(
      API_ENDPOINT.USER_MANAGEMENT.ORGANIZATION.CREATE,
      packageData
    );

    return response.data.data; // return only useful payload
  } catch (error: any) {
    return rejectWithValue(
      error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to create organisation"
    );
  }
});

export const deleteOrganisation = createAsyncThunk(
  "packages/delete",
  async (id: string, { rejectWithValue }) => {
    try {
      await axios.delete(
        `${API_ENDPOINT?.USER_MANAGEMENT?.ORGANIZATION?.DELETE(id)}`,
        { headers }
      );
      return id;
    } catch (err: any) {
      console.error("Delete error:", err);
      return rejectWithValue(
        err.response?.data?.message ||
          err.response?.data?.error ||
          "Failed to Delete Organisation"
      );
    }
  }
);

export const fetchOrganizationDropdown = createAsyncThunk(
  "organization/fetchDropdown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        API_ENDPOINT?.USER_MANAGEMENT?.ORGANIZATION?.DROPDOWN
      );

      return response?.data?.data ?? [];
    } catch (error: any) {
      console.error("fetchOrganizationDropdown error:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to fetch organization dropdown"
      );
    }
  }
);

export const OrganisationsExportsCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();
  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(({ id, value }: { id: string; value: any }) => {
      if (id && value !== undefined && value !== null) {
        if (typeof value === "object" && value !== null) {
          const maybeDateFilter = value as {
            from_date?: string;
            to_date?: string;
          };

          if (
            (maybeDateFilter.from_date || maybeDateFilter.to_date) &&
            (id === "created_at" || id === "updated_at")
          ) {
            if (maybeDateFilter.from_date) {
              params.append(`${id}_from`, maybeDateFilter.from_date);
            }
            if (maybeDateFilter.to_date) {
              params.append(`${id}_to`, maybeDateFilter.to_date);
            }
            return;
          }

          // Other object filters
          Object.entries(value).forEach(([key, val]) => {
            if (val !== undefined && val !== null && val !== "") {
              params.append(key, String(val));
            }
          });
        } else {
          params.append(id, value);
        }
      }
    });
  }

  const response = await Axios.get(
    `${
      API_ENDPOINT?.USER_MANAGEMENT?.ORGANIZATION?.EXPORT
    }?${params.toString()}`,
    {
      responseType: "blob",
    }
  );

  return {
    blob: response.data,
    filename: `${
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "Organisation"
    }_${new Date().toISOString().split("T")[0]}.csv`,
  };
};
